module.exports = __webpack_public_path__ + "static/media/bez_temp_w_domu_grzanie.b36d6667.svg";